import { ToggleButton } from "plos/src/components/ToggleButton";
import { ToggleButtonGroup } from "plos/src/components/ToggleButtonGroup";
import { toggleWrapper } from "plos/src/components/ToggleButtonGroup/toggleButtonGroup.css";
import { useLocalizedNavigate } from "plos/src/hooks/useLocalizedNavigate";
import { Key } from "react";
import { useTranslation } from "react-i18next";

type PrizesView = "prizes" | "winners";

const linksDict = {
  prizes: "/prizes",
  winners: "/prizes/winners",
};

const PrizesNav = ({ selected }: { selected: PrizesView }) => {
  const navigate = useLocalizedNavigate();

  const { t } = useTranslation("prizes");

  const handleToggleChange = (keys: Set<Key>) => {
    const key = Array.from(keys)[0] as PrizesView;
    if (key) {
      navigate(linksDict[key]);
    }
  };

  return (
    <div className={toggleWrapper}>
      <ToggleButtonGroup
        selectedKeys={new Set([selected])}
        onSelectionChange={handleToggleChange}
      >
        <ToggleButton id="prizes">{t("nav.prizes", "Prizes")}</ToggleButton>
        <ToggleButton id="winners">{t("nav.winners", "Winners")}</ToggleButton>
      </ToggleButtonGroup>
    </div>
  );
};

export default PrizesNav;
